function getProperty(data: any, path: string) {
  if (data && path) {
    if (Array.isArray(data)) {
      return data.map((it) => getProperty(it, path))
    }
    return data[path]
  }
}

export function get(data: any, path: string) {
  let result = data
  for (const prop of path.split(/\./)) {
    result = getProperty(result, prop)
  }
  return result
}

export function propertyAccessor(path: string) {
  return (data: any) => get(data, path)
}
